import React, { useMemo } from 'react';

import { useTranslations } from '@lang';
import { PersonalisationMessage } from '../../PersonalisationMessage';
import { DetailTitle, DetailsRow } from '../../styled';
import type { Item } from '@common/components/ItemListingRows/Voucher/Voucher';
import { useIntl } from 'react-intl';
import moment from 'moment';

export type VoucherDetailsProps = {
  item: Item;
  isEditable?: boolean;
};

export const VoucherDetails: React.FC<VoucherDetailsProps> = ({ item, isEditable }) => {
  const { personalization, deliveryDetails } = item;
  const { t } = useTranslations();

  const intl = useIntl();

  const timeOfComponentRender = useMemo(() => new Date(), []);

  const basketExpiryTime = useMemo(() => {
    if (!item?.expireAt) return null;

    return moment.tz(item.expireAt, intl.timeZone || '').format('HH:mm');
  }, [item, timeOfComponentRender, intl]);

  return (
    <div>
      <PersonalisationMessage
        type="voucher"
        item={item}
        personalization={personalization}
        isEditable={isEditable}
      />
      {basketExpiryTime ? <em>Reserved until {basketExpiryTime}</em> : null}
      {deliveryDetails?.packagingName && (
        <DetailsRow>
          <div>
            <DetailTitle showOnMobile>{t('common.giftPackaging')}</DetailTitle>
            <div>{deliveryDetails.packagingName}</div>
          </div>
        </DetailsRow>
      )}
    </div>
  );
};
